import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { withRouter } from 'react-router-dom';
import CustomTable from 'modules/common/components/table';
import { getBreakdowns } from '../services/breakdown.service';
import BreakdownTabsComponent from './breakdownTabs.component';

const statuses = [
  {
    title: 'Nie rozpoczęta',
    status: 0,
  },
  {
    title: 'Otwarta',
    status: 1,
  },
  {
    title: 'W trakcie',
    status: 2,
  },
  {
    title: 'Zakończona',
    status: 3,
  },
];

class Breakdowns extends PureComponent {
  state = {
    data: [],
    totalCount: 0,
    isLoading: true,
  };

  constructor(props) {
    super(props);

    this.tableConfig = {
      columns: [
        {
          caption: 'VIN',
          dataField: 'car.vin',
          sort: true,
        },
        {
          caption: 'Marka',
          dataField: 'car.manufacturer.name',
        },
        {
          caption: 'Model',
          dataField: 'car.model.name',
        },
        {
          caption: 'Grupa Awarii',
          dataField: 'type.name',
        },
      ],
      noItemsFoundText: 'Brak danych',
      initialSort: {
        sortField: 'createdAt',
        sortDirection: 'desc',
      },
      filterFields: 'car.vin',
    };

    if (props.status === 4) {
      this.tableConfig.columns = this.tableConfig.columns.concat({
        caption: 'Status',
        dataField: 'status',
        sort: true,
        renderCell: (status) => statuses.find((statusItem) => statusItem.status === status).title,
      });
    }
  }

  getData = async (params) => {
    const { status } = this.props;
    let newParams = params;

    this.setState({
      isLoading: true,
    });

    if (status !== 4) {
      newParams = Object.assign(params, { status });
    }

    const { data, totalCount } = await getBreakdowns(newParams);

    this.setState({
      data,
      totalCount,
      isLoading: false,
    });
  };

  onRowClick = (ev) => {
    const { history } = this.props;
    const {
      currentTarget: { id },
    } = ev;

    history.push(`/breakdown-details/${id}`);
  };

  render() {
    const { status } = this.props;
    const { data, isLoading, totalCount } = this.state;

    return (
      <div className="content">
        <BreakdownTabsComponent status={status} />
        <CustomTable
          config={this.tableConfig}
          items={data}
          fetchData={this.getData}
          totalCount={totalCount}
          isLoading={isLoading}
          onRowClick={this.onRowClick}
          pagination
        />
      </div>
    );
  }
}

Breakdowns.defaultProps = {};

Breakdowns.propTypes = {
  history: ReactRouterPropTypes.history.isRequired,
  status: PropTypes.number.isRequired,
};

export default withRouter(Breakdowns);
